import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { GastroService } from './gastro.service';

@Injectable({
  providedIn: 'root'
})
export class PathologyPrintService {
  exam
  patient
  load=false
  pathology=[]
  gastro
  signatureUrl = null;
  loadMsg: Subject<null>;

  constructor(private http: HttpClient,public gs:GastroService) {
    this.loadMsg = new Subject();
   }


 
  loadExam(examId) {
    if (examId) {
       this.http.get(`api/gastro/examInfo/pathologyForm/${examId}`).subscribe((data)=>{
        this.exam=data['exam']
        this.patient=data['patient']
        this.pathology=data['pathology']
        this.gastro=data['gastro']
        this.signatureUrl=data['signatureUrl'] || null
        this.gastro['DetailsFindings']=this.gs.getFindings(this.gastro)
        this.gs.buildList(this.gastro['DignosisTree']);
        this.gastro['DiagnosisList'] = this.gs.diagnosis;
        this.load=true
        this.loadMsg.next(undefined)
       })
    }
  }

  getAgeMo(atDate: Date = new Date(), toadd = 0) {
    if (!this.patient.Birth)
      return "";
    let months = toadd + this.monthDiff(new Date(Date.parse(this.patient.Birth)), atDate);//months between birthday and edd (for example)
    let yrs = Math.floor(months / 12);
    let mo = months - yrs * 12;
    return yrs + "y" + mo + "m";
  }

  monthDiff(d1: Date, d2: Date) {
    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    if (d1.getDate() > d2.getDate())
      months--;
    return months <= 0 ? 0 : months;
  }
  
}
